
export default {
    props: {
        name: { type: String, required: true },
        sub: { type: String, default: null },
        addr: { type: String, default: null },
        icon: { type: String, default: 'user' },
        iconVariant: { type: String, default: 'blue' },
        pill: { type: String, default: null },
        // Right-aligned distance badge (e.g. "0.4 mi") — PharmacyStep only;
        // other consumers simply never pass it.
        dist: { type: String, default: null },
        editable: { type: Boolean, default: false },
        // This row is the one currently open in an editor. Highlights it and
        // squares off its bottom corners so the editor attached beneath reads
        // as part of the same row (see MedicationsStep.vue's inline edit panel
        // and `.ck-gt-sel.is-editing` in checkup.scss).
        editing: { type: Boolean, default: false },
    },
}
